import React from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { Loading } from '@guryou/html-components';
import Header from './header';
import SubHeader from './SubHeader';

const TopNavigation = () => {
  const location = useLocation();

  const isRiminiRegistration = location?.pathname.includes('/register-rimini');

  if (isRiminiRegistration) {
    return null;
  }
  return (
    <>
      <Loading />
      <Header />
      <SubHeader />
    </>
  );
};

export default TopNavigation;
